"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useAppEventTypes(query) {
  const { ...rest } = useElements("app-event-types", query);
  return {
    appEventTypes: rest.items,
    ...rest
  };
}

export { useAppEventTypes };
